export default __webpack_public_path__ + "static/reports-7b0b0ee45663d3b181875308bbd029e7.png";